module.exports = __webpack_public_path__ + "static/media/icons.bc48662b.svg";